// 各頁面原本硬編中文抽出的詞條（CB7REQ-170）；key 為語言中性，四語系同步維護
export default {
  "pageText.activity.memberAccountOrPhone": "Member Account / Phone",
  "pageText.activity.freeCheckinPoints": "Free Check-in Points Issued",
  "pageText.activity.depositCheckinPoints": "Deposit Check-in Points Issued",
  "pageText.activity.unit": "Unit",
  "pageText.activity.issueQty": "Issue Quantity",
  "pageText.activity.treasureIssuePHP": "Treasure Box Issued (PHP)",
  "pageText.activity.treasureIssueUSDT": "Treasure Box Issued (USDT)",
  "pageText.activity.treasureIssueVND": "Treasure Box Issued (VND)",
  "pageText.activity.treasureClaimPHP": "Treasure Box Claimed (PHP)",
  "pageText.activity.treasureClaimUSDT": "Treasure Box Claimed (USDT)",
  "pageText.activity.treasureClaimVND": "Treasure Box Claimed (VND)",
  "pageText.activity.treasureExpirePHP": "Treasure Box Expired (PHP)",
  "pageText.activity.treasureExpireUSDT": "Treasure Box Expired (USDT)",
  "pageText.activity.treasureExpireVND": "Treasure Box Expired (VND)",
  "pageText.activity.qtyMustBePositive": "Quantity must be greater than 0",
  "pageText.activity.maxValue": "Max",
  "pageText.activity.minValue": "Min",
  "pageText.activity.maxAmountGteMin": "Max amount must be >= min amount",
  "pageText.activity.idRequired": "ID not filled in",
  "pageText.activity.actPkRequired": "Activity primary key is required; load the activity config first",
  "pageText.activity.filter": "Filter",
  "pageText.activity.queryUserStatusFirst": "Query the user status first",
  "pageText.activity.bonusRangesRequired100": "Configure all bonus ranges with probabilities totaling 100%",
  "pageText.activity.uploadAtLeastOneImage": "Upload at least one image",
  "pageText.activity.addAtLeastOneBonusRange": "Add at least one bonus range",
  "pageText.activity.enterIssueQty": "Enter the issue quantity",
  "pageText.activity.selectItemType": "Select item type",
  "pageText.activity.accountsSemicolonHint": "(separate multiple accounts with ;)",
  "pageText.activity.fileMax50MB": "File must not exceed 50MB!",
  "pageText.financial.failCountLimit5Min": "5-min failure limit",
  "pageText.financial.eg10": "e.g. 10",
  "pageText.financial.eg10000": "e.g. 10000.00",
  "pageText.financial.eg500": "e.g. 500.00",
  "pageText.financial.singlePayLimit": "Single payout limit",
  "pageText.financial.paramSetFailed": "Failed to save parameters",
  "pageText.financial.paramSetSuccess": "Parameters saved",
  "pageText.financial.paramConfigFailed": "Failed to configure parameters",
  "pageText.financial.paramConfigSuccess": "Parameters configured",
  "pageText.financial.teamsGroupHint": "Enter the Teams group name or webhook URL",
  "pageText.financial.rejectFailed": "Rejection failed",
  "pageText.financial.payTypeCode": "Payment Type Code",
  "pageText.financial.payTypeName": "Payment Type Name",
  "pageText.financial.channelNotFound": "Channel not found",
  "pageText.financial.payingInProgress": "Payout in progress",
  "pageText.financial.dailyPayLimit": "Daily payout limit",
  "pageText.financial.confirmDeletePayType": "Delete this payment type?",
  "pageText.financial.confirmRechargeFailed": "Failed to confirm deposit",
  "pageText.financial.confirmRechargeSuccess": "Deposit confirmed",
  "pageText.financial.autoPayoutSwitch": "Auto payout switch",
  "pageText.financial.autoPayoutSort": "Auto payout order",
  "pageText.financial.getPayChannelListFailed": "Failed to load payout channels",
  "pageText.financial.getPayChannelDataFailed": "Failed to load payout channel data",
  "pageText.financial.getParamSetFailed": "Failed to load parameters",
  "pageText.financial.getPayTypeDataFailed": "Failed to load payment types",
  "pageText.financial.getCurrencyListFailed": "Failed to load currencies",
  "pageText.financial.unlockFailed": "Unlock failed",
  "pageText.financial.unlockSuccess": "Unlocked",
  "pageText.financial.enterPayTypeCode": "Enter the payment type code",
  "pageText.financial.enterPayTypeName": "Enter the payment type name",
  "pageText.financial.enterAmountMax2Decimals": "Enter an amount with at most 2 decimals",
  "pageText.financial.notifyGroup": "Notification group",
  "pageText.financial.lockFailed": "Lock failed",
  "pageText.financial.lockSuccess": "Locked",
  "pageText.luckySpin.effectImmediately": "✓ Effective immediately",
  "pageText.luckySpin.validSameDayOnly": "Valid same day only",
  "pageText.luckySpin.validSameDayOnlyDetail": "Valid same day only; expires at 00:00 the next day",
  "pageText.luckySpin.withinValid": "valid within",
  "pageText.luckySpin.multiLangConfigExternal": "Multilingual config (external display)",
  "pageText.luckySpin.daysHoursNotBothZero": "Days and hours cannot both be 0",
  "pageText.luckySpin.hourRange": "Hour range: 0-23",
  "pageText.luckySpin.hourUnit": "h",
  "pageText.luckySpin.effectNextDayMidnight": "Effective at 00:00 the next day",
  "pageText.luckySpin.selectAfterClaimMode": "Select the post-claim mode",
  "pageText.luckySpin.afterClaim": "After claim",
  "pageText.luckySpin.afterClaimMode": "Post-claim mode",
  "pageText.member.anchor": "Streamer",
  "pageText.member.tradeRangeMax7Days": "Transaction time range cannot exceed 7 days",
  "pageText.member.lastOnlineTime": "Last online: ",
  "pageText.member.lastDepositTime": "Last deposit: ",
  "pageText.member.registerTime": "Registered: ",
  "pageText.member.loginDomain": "Login domain: ",
  "pageText.member.getWalletAccountsFailed": "Failed to load wallet accounts",
  "pageText.member.getBankCardsFailed": "Failed to load bank cards",
  "pageText.member.requestFailed": "Request failed",
  "pageText.member.resetWithdrawPwdError": "Error resetting the withdrawal password",
  "pageText.member.resetLoginPwdError": "Error resetting the login password",
  "pageText.member.firstDepositTime": "First deposit: ",
  "pageText.sys.createRole": "Create Role",
  "pageText.sys.failed": "Failed",
  "pageText.sys.opFailedRetry": "Operation failed, please retry",
  "pageText.sys.dataLoadFailed": "Failed to load data",
  "pageText.sys.memberAccount": "Member Account",
  "pageText.sys.messageContent": "Message Content",
  "pageText.sys.updateFailed": "Update failed",
  "pageText.sys.addFailed": "Add failed",
  "pageText.seo.featureInDevelopment": "Feature in development...",
  "pageText.seo.monthlyImpressions": "Monthly Impressions",
  "pageText.seo.monthlyImpressionsGsc": "Monthly Impressions (GSC)",
  "pageText.sms.enterSenderId": "Enter the Sender ID",
  "pageText.sms.countryUS": "US - United States",
  "pageText.risk.supKycPkMissing": "Missing supDataPkCode (supplementary KYC key); cannot submit for review",
  "pageText.risk.supKycNotFound": "Supplementary KYC record not found",
  "pageText.risk.supKycMemberMissing": "Member ID missing in the supplementary KYC record",
  "pageText.risk.formValidateFailed": "Form validation failed; check the required fields",
  "pageText.inbox.startDateTime": "Start date & time",
  "pageText.inbox.endDateTime": "End date & time",
  "pageText.common.loading": "Loading...",
  "pageText.common.noData": "No data",
  "pageText.common.unknown": "Unknown",
  "pageText.common.filter": "Filter",
  "pageText.common.allAgents": "All agents",
  "pageText.activity.eggReady": "Ready to hatch",
  "pageText.activity.hatchedNoEnergy": "Hatched (no energy)",
  "pageText.activity.eg24000": "e.g. 24000",
  "pageText.activity.onlyTopTier": "Only the top tier can be filled",
  "pageText.financial.editPayType": "Edit Payment Type",
  "pageText.financial.addPayType": "Add Payment Type",
  "pageText.financial.getDataFailed": "Failed to load data",
  "pageText.financial.changePayChannelFailed": "Failed to change the payout channel",
  "pageText.risk.rejectFailed": "Rejection failed",
  "pageText.member.streamerUser": "Streamer user",
  "pageText.member.patrolUser": "Patrol user",
  "pageText.member.normalUser": "Regular user",
  "pageText.member.gameCategory3DHall": "3D Hall",
  "pageText.common.autoLogout": "Auto Logout",
  "pageText.common.stay": "Stay",
  "pageText.common.leave": "Leave",
  "pageText.common.autoLogoutReason": "To prevent malicious actions while you are away from your computer",
  "pageText.common.autoLogoutStayHint": "To stay signed in, click \"Stay\"",
  "pageText.common.scrollToTop": "Scroll to top",
  "pageText.common.scrollToBottom": "Scroll to bottom",
  "pageText.common.uploadTimeout": "Upload timed out",
  "pageText.common.imageUploadFailed": "Image upload failed",
  "pageText.common.uploadingImage": "Uploading image...",
  "pageText.common.enterContent": "Enter content...",
  "pageText.common.selectAll": "Select all",
  "pageText.common.selectVipLevel": "Select the VIP level",
  "pageText.common.uploadSuccess": "Upload succeeded",
  "pageText.common.uploadFailed": "Upload failed",
  "pageText.common.metaDescPreview": "The meta description will appear here…"
};
